import { useTranslation } from "react-i18next";

import { ServicesMenu } from "./ServicesMenu";
import type { ServicesMenuItem, ServicesMenuProps } from "./ServicesMenu";
import ngdataIcon from "./assets/menu-icon-ngdata.svg";
import ngidIcon from "./assets/menu-icon-ngid.svg";
import qmsIcon from "./assets/menu-icon-qms.svg";
import toolboxIcon from "./assets/menu-icon-toolbox.svg";
import webgisIcon from "./assets/menu-icon-webgis.svg";

export type NextgisServicesMenuProps = Omit<ServicesMenuProps, "items">;

export function NextgisServicesMenu(props: NextgisServicesMenuProps) {
  const { t } = useTranslation();

  const items: ServicesMenuItem[] = [
    {
      key: "ngid",
      icon: ngidIcon,
      href: "https://my.nextgis.com/profile",
      authHref: "https://my.nextgis.com/profile",
      title: t("services.ngid.title"),
      description: t("services.ngid.desc"),
    },
    {
      key: "webgis",
      icon: webgisIcon,
      href: "https://my.nextgis.com/webgis",
      authHref: "https://my.nextgis.com/webgis",
      title: t("services.webgis.title"),
      description: t("services.webgis.desc"),
    },
    {
      key: "data",
      icon: ngdataIcon,
      href: "https://data.nextgis.com/",
      authHref: "https://data.nextgis.com/login/?next=/",
      title: t("services.data.title"),
      description: t("services.data.desc"),
    },
    {
      key: "toolbox",
      icon: toolboxIcon,
      href: "https://toolbox.nextgis.com/",
      authHref: "https://toolbox.nextgis.com/",
      title: t("services.toolbox.title"),
      description: t("services.toolbox.desc"),
    },
    {
      key: "qms",
      icon: qmsIcon,
      href: "/",
      authHref: "/",
      title: t("services.qms.title"),
      description: t("services.qms.desc"),
    },
  ];

  return <ServicesMenu items={items} {...props} />;
}
